import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useNavigate, useParams } from 'react-router-dom'
import API from '../../../../services/API'
import { Alert, LinearProgress, Stack, Typography } from '@mui/material'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'

const ShiftApplicationHistory = () => {
  const { employeeID } = useParams()
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [applications, setApplications] = useState([])
  const [employeeInfo, setEmployeeInfo] = useState({})
  const [page, setPage] = useState(1)
  const [pageLength, setPageLength] = useState(100)

  const navigate = useNavigate()

  useEffect(() => {
    API.get(
      `/employees/shift-application-history/${employeeID}?skip=${(page - 1) * pageLength
      }&limit=${pageLength}`
    )
      .then((res) => {
        if (res.status === 200) {
          console.log('res.data', res.data)
          setApplications(res.data.applications)
          setEmployeeInfo(res.data.employee)
          console.log(res.data)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Stack gap={1}>
      <Typography variant="title2">Shift Application History</Typography>
      {loading && <LinearProgress />}
      {fetchError && (
        <Alert severity="error">
          Unable to fetch Shift Applications. Please try again later.
        </Alert>
      )}
      <Typography variant="title3">{`${employeeInfo?.userAccount?.firstName || ''
        } ${employeeInfo?.userAccount?.lastName || ''}`}</Typography>
      <CustomDataGrid
        rows={applications}
        columns={[
          {
            field: 'createdAt',
            headerName: 'Application Date',
            renderCell: ({ row }) =>
              moment(row.createdAt).format('DD/MM/YYYY HH:mm'),
            minWidth: 150,
          },
          {
            field: 'eventName',
            headerName: 'Event',
            valueGetter: (value, row) =>
              row?.shift?.event?.title ?? row?.shiftType ?? '',
            minWidth: 200,
            flex: 1,
          },

          {
            field: 'clinicalRole',
            headerName: 'Clinical Role',
            valueGetter: (value, row) => row?.shift?.clinicalRole,
            minWidth: 200,
          },
          {
            field: 'start',
            headerName: 'Start',
            valueGetter: (value, row) => row?.shift?.start,
            renderCell: ({ row }) =>
              row?.shift?.start && moment(row.shift.start).format('DD/MM/YY HH:mm'),
            minWidth: 200,
          },
          {
            field: 'end',
            headerName: 'End',
            valueGetter: (value, row) => row?.shift?.end,
            renderCell: ({ row }) =>
              row?.shift?.end && moment(row.shift.end).format('DD/MM/YY HH:mm'),
            minWidth: 200,
          },
          {
            field: 'status',
            headerName: 'Status',
          },
        ]}
        getRowId={(row) => row._id}
        disableRowSelectionOnClick
        onRowClick={({ row }) =>
          navigate(`/shift-application-history/${employeeID}/${row._id}`)
        }
      />
    </Stack>
  )
}

export default ShiftApplicationHistory
